/**
 * Settings → Auto reminder mail — emails sent by themselves to a contract's
 * people when it nears its limits: hours or tickets used past a share, the
 * end date coming up, or the contract ended. Each rule has its own message
 * template; mail goes from the support mailbox or another SMTP account.
 *
 * A rule fires once per contract per contract period (a renewal, new dates
 * or a new limit make it fire again), and only for contracts in their current
 * period — so switching a rule on never mails every old, long-expired contract.
 */
/**
 *   hours_used   — hours used reach `threshold` % of the contract's hours
 *   tickets_used — tickets used (counted + open) reach `threshold` %
 *   ending_soon  — `threshold` days or fewer before the end date
 *   expired      — the contract ended, at most `threshold` days ago
 *   used_up      — its hours or its tickets are all used
 */
export const SUPPORT_REMINDER_TRIGGERS = [
    'hours_used',
    'tickets_used',
    'ending_soon',
    'expired',
    'used_up',
];
export const SUPPORT_REMINDER_TRIGGER_INFO = {
    hours_used: {
        label: 'Hours used reach',
        threshold: { label: 'Percent of the hours', unit: '%', default: 80 },
    },
    tickets_used: {
        label: 'Tickets used reach',
        threshold: { label: 'Percent of the tickets', unit: '%', default: 80 },
    },
    ending_soon: {
        label: 'End date is near',
        threshold: { label: 'Days before the end date', unit: 'days', default: 30 },
    },
    expired: {
        label: 'Contract has ended',
        threshold: { label: 'Within this many days after the end', unit: 'days', default: 7 },
    },
    used_up: { label: 'Hours or tickets all used', threshold: null },
};
export const SUPPORT_REMINDER_MAILBOXES = ['support', 'smtp'];
/** The words a template can use, as {{key}}. */
export const SUPPORT_REMINDER_PLACEHOLDERS = [
    { key: 'customer_name', label: 'Customer' },
    { key: 'project_name', label: 'Project' },
    { key: 'contract_id', label: 'Contract ID' },
    { key: 'contract_type', label: 'Contract type' },
    { key: 'hours_used', label: 'Hours used' },
    { key: 'hours_total', label: 'Total hours' },
    { key: 'hours_left', label: 'Hours left' },
    { key: 'tickets_used', label: 'Tickets used' },
    { key: 'tickets_total', label: 'Total tickets' },
    { key: 'tickets_left', label: 'Tickets left' },
    { key: 'usage_percent', label: 'Usage %' },
    { key: 'start_date', label: 'Start date' },
    { key: 'end_date', label: 'End date' },
    { key: 'days_left', label: 'Days left' },
    { key: 'account_manager', label: 'Account manager' },
    { key: 'account_manager_email', label: 'Account manager email' },
];
//# sourceMappingURL=support-reminders.js.map